import Box from './Box';
import Text from './Text';
import Icon from './Icon';
import Collapse from './Collapse';
import { translate } from '../locale';
import React, { useState } from 'react';
import { useBooking } from '../BookingProvider';
import CourseItemDetail from './CourseItemDetail';

export default function BookingListViewItem({ course }) {
  const { locale } = useBooking();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Box direction='row' divider>
      <Box width='flex'>
        <Box paddingVertical={8} alignItems='center' cursor='pointer' onClick={() => setIsOpen(!isOpen)}>
          <Box width='flex'>
            <Text size={16} weight={'500'} color='red'>{translate(locale, 'courseType', course.type + (course.part ? course.part : ''))}</Text>
          </Box>
          <Icon icon={isOpen ? 'chevron-up' : 'chevron-down'} size={24} color='red' />
        </Box>

        <Collapse isOpen={isOpen}>
          <CourseItemDetail course={course} />
        </Collapse>
      </Box>
    </Box>
  );
}